<template>
  <div class="w-100 mb-4" v-if="vod[0]">
    <div
      class="container-fluid px-0"
      :style="[hover && { 'z-index': '1111111 !important' }]"
    >
      <div class="row align-items-center mb-3 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-center justify-content-between justify-content-lg-start"
          >
            <span class="carousel_title_new">{{ headerTitle }}</span>
          </div>
        </div>
      </div>
      <div
        class="row mx-0 latest-tv-rails-content"
        id="ContinueWatchingRailsV2"
      >
        <div class="owl-carousel owl-theme" id="continueWatching">
          <div
            class="item"
            v-for="item_vod in vod[0]"
            :key="item_vod.id"
            @mouseover="mouseOver"
            @mouseout="mouseOver"
          >
            <!-- <continueWatchingCard
              :image="imgFiltering(item_vod)"
              :latestTag="formatTimestamp(item_vod.content.dateAvailability)"
              :title="
                item_vod.content.longTitle
                  ? formatString(item_vod.content.longTitle)
                  : ''
              "
              :link="checkLink(item_vod)"
            /> -->
            <vodCard
              :image="imgFiltering(item_vod.content)"
              :imageFeature="imgFiltering(item_vod.content, 'feature')"
              :latestTag="formatTimestamp(item_vod.content.dateAvailability)"
              :title="
                item_vod.content.longTitle
                  ? formatString(item_vod.content.longTitle)
                  : ''
              "
              :link="checkLink(item_vod)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import continueWatchingCard from "../cards/continueWatchingCard.vue";
import vodCard from "../cards/v2/vodCard.vue";
export default {
  data: function() {
    return {
      vod: [],
      headerTitle: "Continue Watching",
      id: 3553,
      hover: false,
      userId: localStorage.getItem("user_id"),
    };
  },
  components: { continueWatchingCard, vodCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 4,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-md"></span>',
          '<span class="fa fa-chevron-right fa-md"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 4,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
        },
      });
    },

    imgFiltering(item, type = null) {
      let imgurl;
      const hasThumb =
        item.data && item.data.images && item.data.images.thumbnail;
      const hasTitle = item.data && item.data.images && item.data.images.title;
      const hasFeature =
        item.data && item.data.images && item.data.images.feature;

      // First try to get the specifically requested type if it exists
      if (type === "thumbnail" && hasThumb) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.thumbnail.path;
      } else if (type === "title" && hasTitle) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" + item.data.images.title.path;
      } else if (type === "feature" && hasFeature) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.feature.path;
      }
      // Fall back to original hierarchy if requested type doesn't exist or no type specified
      else {
        if (hasThumb) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.thumbnail.path;
        } else if (hasTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.title.path;
        } else if (hasFeature) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.feature.path;
        } else {
          imgurl =
            "https://cdn-rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },

    checkLink(obj) {
      var item = obj.content;
      var link;
      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (item.idSchema == "204") {
        //pod episode
        // get main podcast id id=382&eps_id=385
        var podcast_id = item.data.podcast.id;
        link = "/podcastplayer?id=" + podcast_id + "&eps_id=" + item.id;
        // console.log(link);
      }

      return link;
    },

    formatTimestamp(dt) {
      var result;
      var t = new Date(dt);
      var dtplustwo =
        t.getFullYear() +
        "-" +
        (t.getMonth() + 1) +
        "-" +
        (t.getDate() + 2) +
        " 00:00";
      dtplustwo = new Date(dtplustwo).getTime();
      // console.log(t);
      var today = new Date();
      var date =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " 00:00";

      var twodays =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        (today.getDate() + 2) +
        " 00:00";
      var from = new Date(date).getTime(); //today
      var twodaysafter = new Date(twodays).getTime(); //twodaysfromtodaay
      if (dtplustwo >= from && dtplustwo <= twodaysafter) {
        result = true;
      } else {
        result = false;
      }

      return result;
    },

    async getContinueWatchingList() {
      var vm = this;
      var rails_id = vm.id;

      try {
        let response = await axios.get(
          `https://rtb.glueapi.io/v1/user/${
            this.userId
          }/content/viewed?format=json`,
          {
            headers: {
              "X-AUTH-TOKEN": localStorage.getItem("token"),
            },
          }
        );

        var arr = response.data.data;
        var uniq = {};
        if (arr) {
          var arrFiltered = arr.filter(
            (obj) => !uniq[obj.idContent] && (uniq[obj.idContent] = true)
          );
        }

        var store = [];
        arrFiltered.forEach((items) => {
          if (
            items.idContent !== 0 &&
            items.idContent != "0" &&
            items.idContent !== 1229 &&
            items.idContent !== 2 &&
            items.idContent !== 3902 &&
            items.idContent !== 3391
          ) {
            store.push(items);
          }
        });

        vm.vod.push(store);

        Vue.nextTick(
          function() {
            if (vm.vod) {
              vm.installOwlCarousel("#continueWatching");
            }
          }.bind(vm)
        );
      } catch (e) {
        console.log(e);
      }
    },
  },
  mounted() {
    this.getContinueWatchingList();
  },
};
</script>

<!-- new style -->
<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#ContinueWatchingRailsV2 .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #ContinueWatchingRailsV2 .owl-theme:hover {
    z-index: 111;
  }

  #ContinueWatchingRailsV2 .owl-theme {
    height: auto;
  }
  #ContinueWatchingRailsV2 .owl-item {
    z-index: 1;
  }
  #ContinueWatchingRailsV2 .owl-item:hover {
    transition: 0.1s all ease-in-out;
    width: 100%;
    z-index: 2000;
  }

  #ContinueWatchingRailsV2 .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #ContinueWatchingRailsV2 .owl-theme .owl-nav {
    position: absolute;
    top: -64px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 11;
  }

  #ContinueWatchingRailsV2 .owl-prev {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
    z-index: 1;
  }

  #ContinueWatchingRailsV2 .owl-next {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 1;
  }

  #ContinueWatchingRailsV2 .owl-next span,
  #ContinueWatchingRailsV2 .owl-prev span {
    color: rgb(0, 0, 0) !important;
  }
}
</style>

<style scoped>
.carousel_title_new {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(250, 185, 19, 1);
}
.view-all-wrapper {
  border-radius: 8px;
  background: rgba(250, 185, 19, 1);
  padding: 6px 12px;
}
.see-more-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 768px) {
  .carousel_title_new {
    font-size: 18px;
    line-height: 22px;
  }
  .see-more-text {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
